import { useQuery } from "react-query";
import apiService from "../services/apiService";
import find from "lodash/find";
import { useLang } from "./LangHooks";
import { News, NewsArticle } from "../types/News";

//import delay from "../utils/delay";

export function useNews(limit = 100): News {
  const lang = useLang();
  const { data } = useQuery(["news", lang], async () => {
    //await delay(3000); //for testing
    return apiService.loadNews(lang);
  });
  return data.slice(0, limit);
}

export function useNewsArticle(
  _id: number | string,
  fallbackToLatest = false
): NewsArticle | undefined {
  const news: News = useNews();
  let article;
  if (_id) {
    const id: string = typeof _id === "string" ? _id : _id.toString();
    article = find(news, { id: id });
  } else {
    article = undefined;
  }
  if (article || !fallbackToLatest) {
    return article;
  } else {
    return news?.[0];
  }
}
